import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../../core/shared/modal/modal.component';
import { NgForm } from '@angular/forms';
import { PrintoutService } from '../../../../core/services/printout/printout-service.service';

@Component({
  selector: 'app-timesheet-printout-config-modal',
  templateUrl: './timesheet-printout-config-modal.component.html'
})
export class TimesheetPrintoutConfigModalComponent implements OnInit {

  public month: number;
  public year: number;
  public title: string = 'Parametry wydruku';

  private procedureName = 'Supremo.Pdf_EmployeeTimesheet';
  private employeeIds: number[] = [];

  @ViewChild(ModalComponent) public modal: ModalComponent;
  @ViewChild('printoutConfigForm') printoutConfigForm: NgForm;

  constructor(
    private pdfService: PrintoutService
  ) { }

  ngOnInit() {
    this.month = new Date().getMonth() + 1;
    this.year = new Date().getFullYear();
  }

  public closeModal() {
    this.modal.close();
  }

  public setModel(employeeIds: number[]) {
    this.employeeIds = employeeIds;
    this.modal.openWithCustomSize({ maxwidth: '200px' });
  }

  private generatePrintout() {
    if (this.employeeIds.length > 0) {
      var employeeIdsJson = JSON.stringify(this.employeeIds);
      var params = { '@Month': this.month, '@Year': this.year, '@EmployeeIdsJson': employeeIdsJson };
      this.pdfService.makePdfFromProcedure(this.procedureName, params);
      this.closeModal();
    }
  }
}
